import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const JoinCmplt = () => {
  useEffect(() => {
    document.title = '사용자 가입 완료';
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 가입 완료</h2>
      </div>
      <ol className="step-wrap">
        <li className="done">
          <span>
            <i className="sr-only">1단계</i>
            <span className="step-tit">가입 유형 선택</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">2단계</i>
            <span className="step-tit">중복가입 확인</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">3단계</i>
            <span className="step-tit">약관동의</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">4단계</i>
            <span className="step-tit">정보입력</span>
          </span>
        </li>
        <li className="active">
          <span>
            <i className="sr-only">5단계 현재단계</i>
            <span className="step-tit">사용자 가입 완료</span>
          </span>
        </li>
      </ol>

      <div className="join-complete">
        <p className="head-copy">사용자 가입이 완료되었습니다.</p>
        <p className="text">로그인 후 서비스를 이용하실수 있습니다.</p>
        <div className="page-btn-wrap">
          <button
            type="button"
            className="btn xlg primary"
            onClick={() => {
              navigate('/member/login');
            }}
          >
            로그인 바로가기
          </button>
        </div>
      </div>
    </>
  );
};

export default JoinCmplt;
